import { ApiService } from "@core/api/api-service";
import { CreateVipPtInput } from "@domain/register/register-vip/vip-register";
import { VeevaUserRecordData } from "@domain/veeva/veeva";

export class VipRegisterService {
	constructor(private readonly authenticatedApiService: ApiService) {}

	async registerVipUser(veevaPtInput: CreateVipPtInput): Promise<void> {
		await this.authenticatedApiService.post<VeevaUserRecordData>("/pts/vip/register", veevaPtInput);
	}
}
